import PicklistMetadata from "../PicklistMetadata";

// Non-static picklist over the EnterpriseTermCurrent EC used to pick the CHILD term of a relationship.
// Same as EnterpriseTermParent — display = Name, value = EnterpriseTermUSID (the LOGICAL term, one row
// per term) — but excludes the term currently chosen as Parent so a term can't be related to itself.
class EnterpriseTermChildPicklistMetadata extends PicklistMetadata {
    constructor() {
        super();

        this.name = "EnterpriseTermChild";
        this.static = false;
        this.enterpriseComponent = "EnterpriseTermCurrent";
        this.useRealm = false;
        // Persona-sensitive: options are scoped to the active persona (Position/User Group/Work
        // Group) via PlatformSelect -> the EC's visibility-mode/visibility-value headers.
        this.visibilityType = "Persona";
        // Long list (all terms): search the backend as the user types instead of pre-loading and
        // client-filtering (which was capped at the EC's default cache size). Contains match.
        this.serverFilter = true;
        this.serverFilterOperator = "Contains";
        this.serverFilterLimit = 50;
        // Child must be a real term (ChildUSID is a FK) — don't store free-typed text.
        this.mustMatchOption = true;
        this.searchSpecification = null;
        this.sortSpecification = {"Name": "ASC"};
        this.typeField = "Name";
        this.typeValue = "EnterpriseTermUSID";
        this.allowNoSelection = false;
        // Exclude the chosen Parent so a term can't relate to itself. ParentUSID is set on the form
        // EC (not a rendered control on the relationship dialog), so read it from the EC's attribute.
        // The server rejects a self-edge too (CC-ETRL-SELF) — this just keeps it out of the list.
        this.excludeEnterpriseComponentAttributes = ["ParentUSID"];
    }
}

export default EnterpriseTermChildPicklistMetadata;
